/**
 * 适当性
 */
// import $ from "@/common";
const CHECKTYPE_A4 = "A4";
const CHECKTYPE_A5 = "A5";//直销还未启用A5
const CERT_STATE = {NONE: "0", VALID: "1", VERIFYING: "2", VERIFYFAIL: "3", OUTDATE: "4"}//请上传，上传成功，上传待审核，上传失败，过期
const CERT_STATE_CH =  {"0": "请上传", "1": "已上传", "2": "待审核", "3": "审核失败", "4": "已过期", "": ""}
const CERTDATE_VALID_STATE = {"INVALID": "2"}//已过期
const CHECK_API = [];
const CHECK_TYPE = {LOGIN: 1, ERROR: 2};
const BUSINFLAGMAP = {"022": "|buyForm|purchaseOrderFrom|chargeForm|",
"024": "|redeemForm|encashForm|saleForm|transForm|",
"036": "|trans|",
"090": "|fixChargeForm|fixDeclareForm|"}

export default {
  CERT_STATE_CH: CERT_STATE_CH,
  CERTDATE_VALID_STATE: CERTDATE_VALID_STATE,
  CHECK_TYPE: CHECK_TYPE,
  /**
   * 
   * 如果任何一个接口报DS-TR050105，说明交易受限，这时要查一下因为什么原因受限，再跳转
   * 对错误码处理
   */
  // checkHgx(process, option = {}) {
  // 	option.from = this.CHECK_TYPE.LOGIN;
  //   getHgxLimit(option).then((jsonResult) => {
  //     if (jsonResult.successful) {
  //       let result = checkHgxLimitList(jsonResult.result, option); //true有待办事项 , false没有待办事项
  //       process && process(result);
  //     } else {
  //     	process(true)//如果检查待办事项有现服务端异常,先过去,交易进再拦截
  //     }
  //   })
  // },
  /**
   * 查询用户照片上传状态
   * {NONE: "0", VALID: "1", VERIFYING: "2", VERIFYFAIL: "3", OUTDATE: "4"}//请上传，上传成功，上传待审核，上传失败，过期
   */
  // getCertPhotoState(process) {
  //   getHgxLimit().then((jsonResult) =>  {
  //     if (jsonResult.successful) {
  //       let hgxLimitList = jsonResult.result;
  //       if (hgxLimitList && hgxLimitList.length > 0) {
  //         //遍历类型A4的记录
  //         let hgxA4LimitTypeList = checkHgxType(hgxLimitList, CHECKTYPE_A4);
  //         if (hgxA4LimitTypeList.length > 0) {
  //           let A4Limit = hgxA4LimitTypeList[0];
  //           if (A4Limit.verifystatus == "00") {
  //             process(CERT_STATE.VERIFYING);//已上传，待审核
  //           } else if (A4Limit.verifystatus == "01") {
  //             process(CERT_STATE.VERIFYFAIL);//已上传，审核失败
  //           } else {
  //             process(CERT_STATE.NONE)//请上传
  //           }
  //         } else {
  //           //遍历类型A5的记录
  //           let hgxA5LimitTypeList = checkHgxType(hgxLimitList, CHECKTYPE_A5);
  //           if (hgxA5LimitTypeList.length > 0) {
  //             process(CERT_STATE.OUTDATE);//证件照已过期，
  //           } else {
  //             process(CERT_STATE.VALID);//照片已上传且有效
  //           }
  //         }
  //       } else {
  //       	process(CERT_STATE.VALID);
  //       }
  //     }
  //   })
  // },
  /**
   * 拦截所有form表单接口，传业务代码
   * @param {*} api 
   * @param {*} param 
   */
  initHGXParam(apiUrl, param) {
    let urlWords = apiUrl.split("/");
    let lastApiName = "|" + urlWords[urlWords.length-1].replace("pmt", "").toLowerCase() + "|";
    for (let businflag in BUSINFLAGMAP) {
      let pattern = BUSINFLAGMAP[businflag].toLowerCase();
      if (pattern.indexOf(lastApiName) >= 0) {
        param.antiMoneyBusinestype = businflag;
        break;
      }
    }
    return param;
  },
  // checkError(jsonResult) {
  // 	let option = {from: this.CHECK_TYPE.ERROR};
  // 	if (jsonResult.successful == false) {
  //     if (jsonResult.code == "BTS-5BP00091") {
  // 			checkHgxLimitList(jsonResult.result, option);
  //       return false;
  //     }
  //     if (/^合规性校验.*交易账号.*限制交易$/.test(jsonResult.message)) {
  //     	getHgxLimit(option).then((jsonResult) => {
  //     		if (jsonResult.successful) {
  //     			checkHgxLimitList(jsonResult.result, option); //true有待办事项 , false没有待办事项
  //     		} else {
  //     			$.alert("交易账号受限");
  //     		}
	// 	    })
  //     	return false;
  //     }
  //   }
  // 	return true;
  // }
};
//查找某类型的数据
// function checkHgxType(hgxLimitList, type) {
//   var result = hgxLimitList.filter(item => {
//     return item.checktype == type;
//   });
//   return result;
// }
//跳转对应的处理页面，如果page为空，则返回
// function processHgx(msg, page, {needTip = true, closeSelf = true, backBtn = true, param = {}}) {
//   if (needTip === true) {
//     if (page && page != "") {
//       $.confirm(msg, "前往", () => {
//         if (closeSelf) {
//           $.route.hsOpenAndCloseSelf(page, param);
//         } else {
//           $.route.hsOpen(page, param);
//         }
//       }, () => {
//       	$.route.hsBack();
//       });
//     } else {
//       $.alert(msg, () => {
//         backBtn && $.route.hsBack();
//       });
//     }
//   }
// }
//yyyymmdd转在yyyy年mm月dd日
// function dateToChinese(yyyymmdd) {
//   return `${yyyymmdd.substr(0, 4)}年${parseInt(yyyymmdd.substr(4, 2))}月${parseInt(yyyymmdd.substr(6, 2))}日`;
// }
//检验是否还在缓冲期内
// function isInBufferDate(hgxLimit) {
//   return (
//     hgxLimit.isOverdue != "1"
//   );
// }

/**
   * 根据限制列表数据，按照A2A1A4A5A3的优先级顺序来进行合规性提示，目前只在登录时显示
   * @param {*} jsonResult
   * @param {*} isBuyBusin
   * @returns true: 没有待办事项; false:有待办事项
   */
// function checkHgxLimitList(hgxLimitList, option) {
//   var hgx = $.config.antiMoney.hgx;
//   if (hgxLimitList && hgxLimitList.length > 0) {
//     for (var checktype in hgx.checktype) {
//       //遍历各种类型的记录
//       let hgxLimitTypeList = checkHgxType(hgxLimitList, checktype);
//       if (hgxLimitTypeList.length > 0) {
//         let hgxLimit = hgxLimitTypeList[0];
//         let checktypeConfig = hgx.checktype[checktype];
//         let msgAll = checktypeConfig.tip;
//         let processPage = checktypeConfig.page;
//         if (checktype === CHECKTYPE_A4) {//如果是A4状态，要特殊处理
//           if (hgxLimit.verifystatus == "00") {//审核中,不需要引导去补传页面,如果是登录时检验，则不提示
//             msgAll = checktypeConfig.tip3;
//             processPage = null;//不跳转，只返回
//             if (option.from == CHECK_TYPE.LOGIN) {//如果是登录时检验A4待审核，则不提示，就当做没有待办事项.
//             	return true;
//             }
//           }
//           if (hgxLimit.verifystatus == "01") {//审核失败,还要再往下做证件类型识别判断
//             msgAll = checktypeConfig.tip4;
//           }
//           $.fund.getAccoInfo(false, false).then((jsonResult) => {
//           	if (jsonResult.accountInfo.identitytype != "0") {//非身份证要求上传证件的，提示去柜台操作。该方案是临时方案，直销要调整方案。
//           		if (hgxLimit.verifystatus != "00") {//审核状态时，仍然使用tip3提示
//           			msgAll = checktypeConfig.tip5;//不管是没有上传，还是审核失败。非身份证的用户都提示去柜台上传。
//           		}
//           		processPage = null;//不跳转到上传页面
//           	}
//           	if (isInBufferDate(hgxLimit)) {//不在有前效期内的，需要拼提示语
// 	            let msgFinishDate = checktypeConfig.tip2;
// 	            msgFinishDate = msgFinishDate.replace(
// 	              "$date",
// 	              dateToChinese(hgxLimit.bufferenddate)
// 	            );
// 	            msgAll = msgAll.replace("$tip2", msgFinishDate);
// 	          } else {
// 	          	msgAll = msgAll.replace("$tip2", "");
// 	          }
// 	          option["param"] = {checkAge18: "false"};
//           	processHgx(msgAll, processPage, option);
//           });
//         } else {
//         	processHgx(msgAll, processPage, option);
//         }
//         return false; //找到第一个需要提示的项即可知道有待办事项
//       }
//     }
//     return true;//如果在for循环里没有遍历到配置项里配置的checktype，就表示移动端没有要处理的待办事项。比如A0
//   } else {
//     return true;
//   }
// }

/**
 * 查询直销5F接口
 */
// function getHgxLimit(opt={updatetradelimit:"0"}) {
// 	let form = $.form.builder().add("updatetradelimit", opt.updatetradelimit);
//   return $.http.req("account/account/hgxTradeRestrictQuery", form);
// }

